export const STREET_MAX_LENGTH = 150;
export const ZIP_MIN_LENGTH = 1000;
export const ZIP_MAX_LENGTH = 99999;
export const CITY_MAX_LENGTH = 150;
export const OTHER_REASON_MAX_LENGTH = 500;
export const EMAIL_MAX_LENGTH = 150;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const NEW_PROJECT_NAME_MAX_LENGTH = 150;
